import React from 'react';
import Container from '../../layout/container'
import TextIntroStyle from './style'

export default function TextIntro() {
  return (
    <TextIntroStyle>
      <Container>
        <h2>Descubre la belleza</h2>
        <h3>de tu propio negocio. Da el primer paso</h3>
        <p>
          Haz parte de nuestra red de miles de emprendedores alrededor del mundo y descubre la belleza detrás de cada persona, cada mirada y cada gesto de amor.  Sorprende con la calidad de nuestros productos y aumenta tus ingresos.
        </p>
      </Container>
    </TextIntroStyle>
  )
}